// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_8ca","cls2":"ResearchInterestTags-cls2_IN4 ResearchInterestTags-cls1_8ca"};